import script from "./DocumentRascunho.vue?vue&type=script&setup=true&lang=js"
export * from "./DocumentRascunho.vue?vue&type=script&setup=true&lang=js"

import "./DocumentRascunho.vue?vue&type=style&index=0&id=50b4b56c&scoped=true&lang=css"

import exportComponent from "/home/runner/work/Smart2Docs_Front-end/Smart2Docs_Front-end/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-50b4b56c"]])

export default __exports__